import { getEndpoint } from "@/lib/endpoint";
import { GraphQLClient } from "graphql-request";
import { createContext } from "react";

// Use production for default so that Typescript doesn't fall back to string | null
export const EndpointContext = createContext("https://rom.roqua.nl/graphql");
export const { Provider } = EndpointContext;

export function useClient() {
  return new GraphQLClient(getEndpoint(), {
    credentials: "include",
    cache: "no-store",
    mode: "cors",
    headers: {
      "X-Grant-Type": "client_area",
    },
  });
}
